import {
  maxLength,
  required,
  email,
  compare,
  password,
  or,
} from '@rxweb/reactive-form-validators';

export class LoginModel {
  /* @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 20, message: 'No puede tener más de 20 caracteres.' })
    firstName: string;

    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 20, message: 'No puede tener más de 20 caracteres.' })
    lastName: string;*/

  @maxLength({ value: 255, message: 'El correo debe tener máximo 255 caracteres.' })
  @required({
    message: 'Este campo es obligatorio.',
  })
  @or({
    validation: {
      email:  { message: "Ingrese una dirección de correo válida." },
      pattern: {
        expression: {
          alphaNumeric: /^3[0-9]{9}$/,
        },
        message: "El número no es válido.",
      }
    },
    message: "El número de celular o el correo electrónico no son válidos."
  })
  email: string;
  
  @maxLength({
    value: 25,
    message: 'La contraseña debe tener máximo 25 caracteres.',
  })
  @required({ message: 'Este campo es obligatorio. ' })
  password: string;
}
